import { buildTrialInfoOrUndefined } from './TrialInfo';
export const buildCurrentUserResponseOrNull = (data) => {
    if (!data)
        return null;
    const result = {
        activePlanId: data.activePlanId || '',
        activePlanGroup: data.activePlanGroup || '',
        ownPlanId: data.ownPlanId || '',
        ownPlanGroup: data.ownPlanGroup || '',
        activeTrialInfo: buildTrialInfoOrUndefined(data.activeTrialInfo),
        lastTrialInfo: buildTrialInfoOrUndefined(data.lastTrialInfo),
        email: data.email || '',
        firstName: data.firstName || '',
        lastName: data.lastName || '',
        name: data.name || '',
        uid: data.uid || '',
    };
    return result;
};
export const buildCurrentUserResponseOrEmpty = (data) => {
    if (!data) {
        return {
            activePlanId: 'FREE_2016',
            activePlanGroup: 'Free',
            ownPlanId: 'FREE_2016',
            ownPlanGroup: 'Free',
            activeTrialInfo: undefined,
            lastTrialInfo: undefined,
            email: undefined,
            firstName: undefined,
            lastName: undefined,
            name: undefined,
            uid: undefined,
        };
    }
    return {
        activePlanId: data.activePlanId || 'FREE_2016',
        activePlanGroup: data.activePlanGroup || 'Free',
        ownPlanId: data.ownPlanId || 'FREE_2016',
        ownPlanGroup: data.ownPlanGroup || 'Free',
        activeTrialInfo: buildTrialInfoOrUndefined(data.activeTrialInfo),
        lastTrialInfo: buildTrialInfoOrUndefined(data.lastTrialInfo),
        email: data.email || undefined,
        firstName: data.firstName || undefined,
        lastName: data.lastName || undefined,
        name: data.name || undefined,
        uid: data.uid || undefined,
    };
};
